import React, { forwardRef } from "react";

import { StldToggleSwitch, CheckBoxWrapper, CheckBox, CheckBoxLabel } from '../../styled-components/StyledToggleSwitch.style';

export const ToggleSwitch = forwardRef(({ config, setStatus }, ref) => {

    const sendStatus = (event) => {
        const isChecked = event.target.checked;
        if (!!setStatus) {
            setStatus(isChecked);
        }
    }

    return (
        <StldToggleSwitch>
            <CheckBoxWrapper>
                <CheckBox ref={ref} id={'checkbox' + (config?.id ?? config.name)} type="checkbox" defaultChecked={config.status} name={config.name} value={config.status} onChange={(e) => sendStatus(e)} />
                <CheckBoxLabel htmlFor={'checkbox' + (config?.id ?? config.name)} /> {config.label}
            </CheckBoxWrapper>
        </StldToggleSwitch>
    )
});